import { ONBOARDING_MARKETING_FREE } from 'getting-started-shared-tasks/onboardingKeys';
import { FREE_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { MARKETING_SIGNUP } from '../constants/signupConstants';
import { EXPERIENCE_NONE_PARAM } from '../constants/surveyConstants';
import { HubletUrl } from '../utils/urls';
import { ONBU025_EXPERIMENT_KEY, ONBU025_VARIANT_GROUP } from '../constants/experimentConstants';
const marketingExperiencesChecks = [{
  // Note: ONBU025 variant users see the same experience except with the variant groupkeys
  // The only change in these groupkeys is that the 'create contact' and 'create deal' tasks go to the corresponding wizard instead of a tour
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/marketing-tour/${portalId}/start-demo`,
      view: ONBOARDING_VIEWS.MARKETING,
      onboardingKey: ONBOARDING_MARKETING_FREE,
      groupKey: FREE_GROUP_KEYS.freeMarketingViewWizard
    };
  },
  checks: [{
    signupExperimentTreatments: {
      [ONBU025_EXPERIMENT_KEY]: ONBU025_VARIANT_GROUP
    },
    signupType: MARKETING_SIGNUP,
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/marketing-tour/${portalId}/start-demo`,
      view: ONBOARDING_VIEWS.MARKETING,
      onboardingKey: ONBOARDING_MARKETING_FREE,
      groupKey: FREE_GROUP_KEYS.freeMarketingView
    };
  },
  checks: [{
    signupType: MARKETING_SIGNUP,
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.MARKETING,
      onboardingKey: ONBOARDING_MARKETING_FREE,
      groupKey: FREE_GROUP_KEYS.freeMarketingViewWizard
    };
  },
  checks: [{
    signupExperimentTreatments: {
      [ONBU025_EXPERIMENT_KEY]: ONBU025_VARIANT_GROUP
    },
    signupType: MARKETING_SIGNUP
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.MARKETING,
      onboardingKey: ONBOARDING_MARKETING_FREE,
      groupKey: FREE_GROUP_KEYS.freeMarketingView
    };
  },
  checks: [{
    signupType: MARKETING_SIGNUP
  }]
}];
export default marketingExperiencesChecks;